import { jsxs as x, jsx as o } from "react/jsx-runtime";
import { clsx as c } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { RocheUIIcon as v } from "../icon/roche-icon.js";
import { RocheUILanguageSwitch as I } from "../language-switch/roche-language-switch.js";
import { RocheUILanguageSwitchLayoutType as y } from "../language-switch/roche-language-switch.types.js";
import { isCurrentPage as s } from "../mobile-navigation/roche-mobile-navigation-helpers.js";
import t from "./roche-meta-navigation.module.scss.js";
const B = ({
  nav: _,
  secondaryNavLabel: p,
  searchLink: a,
  worldWideLink: e,
  currentPage: m,
  languageSwitchConfig: l
}) => {
  const n = ((l == null ? void 0 : l.alternates) ?? []).length > 0, b = !!(n || e || a), N = () => e != null && e.url ? /* @__PURE__ */ o(
    "a",
    {
      href: e.url,
      className: c(t["meta-navigation__item"], t["meta-navigation__item--icon"]),
      onClick: e.onClick,
      "aria-label": e.label,
      children: i()
    }
  ) : /* @__PURE__ */ o(
    "button",
    {
      className: c(t["meta-navigation__item"], t["meta-navigation__item--icon"]),
      type: "button",
      onClick: e == null ? void 0 : e.onClick,
      "aria-label": e == null ? void 0 : e.label,
      children: i()
    }
  ), i = () => /* @__PURE__ */ o("span", { className: t["meta-navigation__item-icon"], children: /* @__PURE__ */ o(v, { icon: "globe", height: "20px", decorative: !0 }) });
  return /* @__PURE__ */ x("nav", { className: t["meta-navigation"], "aria-label": p, children: [
    /* @__PURE__ */ o("ul", { className: t["meta-navigation__items"], children: _ == null ? void 0 : _.map((r, u) => /* @__PURE__ */ o(
      "li",
      {
        className: c(
          t["meta-navigation__item"],
          s(r.url, m) && t["meta-navigation__item--active"]
        ),
        children: /* @__PURE__ */ o(
          "a",
          {
            className: t["meta-navigation__item-link"],
            href: r.url,
            onClick: r.onClick,
            "aria-current": s(r.url, m) ? "page" : void 0,
            children: r.text ?? ""
          }
        )
      },
      u
    )) }),
    b && /* @__PURE__ */ o("div", { className: t["meta-navigation__separator"] }),
    n && l && /* @__PURE__ */ o(
      I,
      {
        currentLocale: l.currentLocale,
        currentPage: m,
        alternates: l.alternates,
        translatedLocale: l.translations.translatedLocale,
        translatedAriaLabel: l.translations.translatedAriaLabel,
        layout: y.DROPDOWN,
        onClick: l.handleClickTracking
      }
    ),
    e && N(),
    (a == null ? void 0 : a.url) && /* @__PURE__ */ o(
      "a",
      {
        className: c(
          t["meta-navigation__item"],
          t["meta-navigation__item--icon"],
          s(a == null ? void 0 : a.url, m) && t["meta-navigation__item--active"]
        ),
        href: a.url,
        onClick: a == null ? void 0 : a.onClick,
        "aria-label": a == null ? void 0 : a.label,
        "aria-current": s(a.url, m) ? "page" : void 0,
        children: /* @__PURE__ */ o("span", { className: t["meta-navigation__item-icon"], children: /* @__PURE__ */ o(v, { icon: "search", height: "20px", decorative: !0 }) })
      }
    )
  ] });
};
export {
  B as RocheUIMetaNavigation
};
